import { IEvent } from './Event.interfaces';
import Event from './Event';

export default Event as any as React.StatelessComponent<IEvent>;
